(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ks-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-product-detail-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ks-detail-carousel')) {
    customElements.define('ks-detail-carousel', class extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-ks-detail-rail]');
        this.cards = [...this.querySelectorAll('[data-ks-detail-card]')];
        this.dots = [...this.querySelectorAll('[data-ks-detail-dot]')];
        if (!this.rail || this.cards.length < 2) return;

        this.dots.forEach((dot, index) => dot.addEventListener('click', () => {
          this.cards[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }));

        let frame;
        this.rail.addEventListener('scroll', () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => this.updateDots());
        }, { passive: true });
        this.updateDots();
      }

      updateDots() {
        const railLeft = this.rail.getBoundingClientRect().left;
        let active = 0;
        let distance = Infinity;
        this.cards.forEach((card, index) => {
          const nextDistance = Math.abs(card.getBoundingClientRect().left - railLeft);
          if (nextDistance < distance) {
            distance = nextDistance;
            active = index;
          }
        });
        this.dots.forEach((dot, index) => {
          const selected = index === active;
          dot.classList.toggle('is-active', selected);
          dot.setAttribute('aria-current', String(selected));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
